import { render, staticRenderFns } from "./CompoundChart.vue?vue&type=template&id=70497f24&"
import script from "./CompoundChart.vue?vue&type=script&lang=js&"
export * from "./CompoundChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports